import { render, staticRenderFns } from "./Pretreatment.vue?vue&type=template&id=293d3c06&scoped=true"
import script from "./Pretreatment.vue?vue&type=script&lang=js"
export * from "./Pretreatment.vue?vue&type=script&lang=js"
import style0 from "./Pretreatment.vue?vue&type=style&index=0&id=293d3c06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293d3c06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VRow,VSelect})
